import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CameraService} from "../../../modules/core/services/camera-service/camera-service";
import {Content, NavParams, ViewController} from "ionic-angular";
import {TextServiceProvider} from "../../../modules/core/services/text-service/text-service";

@Component({
  selector: 'sellions-take-photo',
  templateUrl: 'sellions-take-photo.html'
})
export class SellionsTakePhoto implements OnInit, OnDestroy {

  @ViewChild('video') video: ElementRef;
  @ViewChild('photo') photo: ElementRef;
  @ViewChild('content') scrollContent: Content;
  private stream: MediaStream;
  private img: string;
  public loading: boolean;
  public sourceType: number;

  constructor(private cameraServ: CameraService,
              private viewCtrl: ViewController,
              public textServ: TextServiceProvider,
              private navParams: NavParams) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.sourceType = this.navParams.get('sourceType');
    if (this.sourceType === 1 && this.cameraServ.canTakePhoto()) {
      navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
          facingMode: 'user'
        }}).then((stream: MediaStream) => {
        this.stream = stream;
        this.video.nativeElement.srcObject = stream;
        this.loading = false;
      });
    } else {

      this.loading = false;
    }
  }

  ngOnDestroy(): void {
    if (this.stream) {
      this.stream.getTracks()[0].stop();
    }
  }

  takePhoto() {
    const canvas = document.createElement("canvas");
    const video = this.video.nativeElement;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0);
    this.img = canvas.toDataURL("image/webp");
    this.photo.nativeElement.src = this.img;
  }

  savePhoto() {
    if (this.img) {
      this.viewCtrl.dismiss(this.img);
    }
  }

  deletePhoto() {
    this.img = '';
  }

  public handleImgInput(event) {
    this.img = URL.createObjectURL(event.target.files[0]);
    this.photo.nativeElement.src = this.img;
    this.scrollContent.resize();
  }

  public close() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-take-photo/sellions-take-photo.ts